module.exports = __webpack_public_path__ + "img/bz.b76fcd7.svg";